import React, { useState } from 'react';
import {
  Text,
  Toggle,
  Space,
  InputField,
  InputWithAction,
  Conditional,
  Icon,
} from '@cashfree-intl/coherent';

import { SplitRow } from '../styled';
import { VendorWiseSplitFieldsProps } from '../types';

const VendorWiseSplitFields = ({
  //   showError,
  // eligibilityStatus,
  currency,
  merchantAmount,
  values,
  formikProps,
  errors,
  handleFieldBlur,
  handleFieldChange,
  vendorsStatus,
  touched,
  splitVendorArray,
  initialMerchantAmount,
}: VendorWiseSplitFieldsProps) => {
  const [previousSplitVendorArray, setPreviousSplitVendorArray] = useState([]);

  const handleToggle = () => {
    const newSplitRefundValue = !values.splitRefund;
    if (!newSplitRefundValue) {
      setPreviousSplitVendorArray(values.splitVendorArray);
      formikProps.setFieldValue('splitVendorArray', []);
      formikProps.setFieldValue('merchantUpdatedArray', []);
      formikProps.setErrors({
        ...formikProps.errors,
        splitVendorArray: [],
      });
    } else {
      formikProps.setFieldValue(
        'splitVendorArray',
        previousSplitVendorArray.length > 0
          ? previousSplitVendorArray
          : values.splitVendorArray,
      );
    }

    formikProps.setFieldValue('splitRefund', newSplitRefundValue);
  };

  const handleDelete = index => () => {
    const filterArrayByIndex = (array, indexToRemove) =>
      array.filter((_, i) => i !== indexToRemove);

    formikProps.setFieldValue(
      'splitVendorArray',
      filterArrayByIndex(values.splitVendorArray, index),
    );

    formikProps.setFieldValue(
      'merchantUpdatedArray',
      filterArrayByIndex(values.merchantUpdatedArray, index),
    );
  };

  return (
    <>
      <Text variant="b12" color="bodyLight" className="mt-1 mb-3">
        {currency} {merchantAmount}{' '}
        <span className="w-500">will be deducted from your account.</span>
      </Text>
      {/* <div className="divider" /> */}
      <Space
        justifyContent="space-between"
        // className={eligibilityStatus ? 'left-align' : ''}
      >
        <Text variant="b14" className="split-header" strong>
          Vendor-wise Split Amount
        </Text>
        <div>
          <Toggle
            id="splitRefund"
            name="splitRefund"
            label="Split Refund"
            active={values.splitRefund}
            onToggle={handleToggle}
            onChange={handleFieldChange}
            onBlur={handleFieldBlur}
            disabled={!formikProps.isValidating && formikProps.isSubmitting}
          />
        </div>
      </Space>
      <Conditional
        if={errors.splitAmount && values.splitRefund && !errors.refundAmount}
      >
        <Text variant="b12" color="danger" className="split-error mt-1">
          {errors.splitAmount}
        </Text>
      </Conditional>

      <div className="scroll-bar mt-2">
        <Conditional if={values.splitRefund}>
          {values.splitVendorArray.map((value, index) => {
            const err =
              errors.splitVendorArray &&
              errors.splitVendorArray[index] &&
              errors.splitVendorArray[index].amount;
            return (
              // eslint-disable-next-line react/no-array-index-key
              <SplitRow alignItems="flex-start" gap={2.5} key={index}>
                <div>
                  <Text variant="b14" color="bodyLight" className="mb-1">
                    Vendor Name
                    {vendorsStatus && vendorsStatus[index] === 'DELETED' && (
                      <span className="deleted-label small-text">
                        (Deleted)
                      </span>
                    ) // eslint-disable-line
                    }
                  </Text>
                  <InputField
                    fluid
                    className="vendorNameField"
                    id={`vendorName[${index}]`}
                    name={`vendorName[${index}]`}
                    errors={errors}
                    touched={touched}
                    value={value.name}
                    disabled
                  />
                </div>
                <div>
                  <Text variant="b14" color="bodyLight" className="mb-1">
                    Amount
                  </Text>
                  <InputWithAction
                    className={`input-field-with-text-label mb-1 ${
                      err || errors.splitAmount ? 'error_border' : ''
                    }`}
                    id={`splitVendorArray[${index}].amount`}
                    name={`splitVendorArray[${index}].amount`}
                    label={{ basic: true, content: currency }}
                    value={value.amount}
                    placeholder="Amount"
                    onChange={(e, data) => {
                      const pattern = /^[0-9.]*$/;
                      if (!pattern.test(e.target.value) && e.target.value) {
                        return;
                      }
                      if (splitVendorArray[index].amount !== e.target.value) {
                        const updatedArr = [];
                        updatedArr[index] = 'Merchant amount updated';
                        formikProps.setFieldValue(
                          'merchantUpdatedArray',
                          updatedArr,
                        );
                      } else {
                        formikProps.setFieldValue('merchantUpdatedArray', []);
                      }
                      handleFieldChange(e, data);
                    }}
                    onBlur={handleFieldBlur}
                    disabled={
                      (vendorsStatus && vendorsStatus[index] === 'DELETED') ||
                      !values.splitRefund
                    }
                  />
                  <Conditional if={err && values.splitRefund}>
                    <Text variant="b12" color="danger">
                      {err}
                    </Text>
                  </Conditional>
                  <Conditional
                    if={
                      values.merchantUpdatedArray[index] &&
                      !err &&
                      merchantAmount !== initialMerchantAmount &&
                      values.splitRefund
                    }
                  >
                    <Text variant="b12" color="success">
                      Merchant amount updated
                    </Text>
                  </Conditional>
                </div>
                <div
                  className="mt-4 cursor-pointer"
                  onClick={handleDelete(index)}
                  data-event-name="Payments_RefundForm_Icon_Close"
                  data-ignore-inner-text="true"
                  data-event-properties={JSON.stringify({
                    index,
                  })}
                >
                  <Icon name="delete" />
                </div>
              </SplitRow>
            );
          })}
        </Conditional>
      </div>
      {/* <div className="balance-content-divider mb-3" /> */}
    </>
  );
};

export default VendorWiseSplitFields;
